import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../Components/SearchBar'
import { Form } from 'react-bootstrap';
import authInstance from '../Classes/AuthHandler';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {getAllPODetails} from '../store/actions/projectNoActions'
import {connect} from 'react-redux'
import AuthHandlerInstance from '../Classes/AuthHandler'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
// function formatDate(date) {
//     var d = new Date(date),
//     month = '' + (d.getMonth() + 1),
//     day = '' + d.getDate(),
//     year = d.getFullYear();
    
//     if (month.length < 2) 
//     month = '0' + month;
//     if (day.length < 2) 
//     day = '0' + day;
    
//     return [day, month, year].join('-');
//   }
  
  
   class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        this.state={
        projectId: this.props.location.state.projId,
        projectNo: this.props.location.state.projNo,
        orderId: this.props.location.state.ordId,
        orderNo: this.props.location.state.orderNo,
        supplierId: this.props.location.state.supId,
        supplierName: this.props.location.state.supName,
        select: true,
        open: false,
        selectAll: false,
        checked: [],
        opacity:"",
        multiCollapseIndex:"",
        data:[],
        searchInput: "",
      }
      
      this.togglebutton = this.togglebutton.bind(this); 
      this.handleChange = this.handleChange.bind(this);
      this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this)
    
    }
  

    togglebutton=(Index)=> {      
        var multiCollapseIndex = this.state.multiCollapseIndex
        if(multiCollapseIndex!=Index || multiCollapseIndex==''){        
         this.setState({multiCollapseIndex:Index})
      } 
    } 
    
      
      toggleVersionModal(e){  
        this.setState({ OpenVersionModal: !this.state.OpenVersionModal });      
      }

      toggleSuccessModal(e){
        this.setState({ UploadSuccessModal: !this.state.UploadSuccessModal });
        if(this.state.UploadSuccessModal ==true){
          this.setState(
          {opacity:""}
          )
         }
      else{
          this.setState(
             {opacity:"0.2"} 
          )        
          }       
      }

      handleChange = () => {   
        var selectAll = !this.state.selectAll;
        this.setState({ selectAll: selectAll });
        var checkedCopy = [];
        this.state.tableData.map(function(e, index) {
          checkedCopy.push(selectAll);
        });
        this.setState({
          checked: checkedCopy
        });
      };
  
      handleSingleCheckboxChange = index => {
        console.log(index);
        var checkedCopy = this.state.checked;
        checkedCopy[index] = !this.state.checked[index];
        if (checkedCopy[index] === false) {
          this.setState({ selectAll: false });
        }
        this.setState({
          checked: checkedCopy
        });
      };
  
      componentDidMount(){
        console.log( this.state.orderId, this.state.projectId, this.state.supplierId, this.state.searchInput)
        // params for PO details store
        var input_obj = {
          // "OrderId": 0,
          // "ProjectId": 0,
          "VendorId": this.state.supplierId,
          // "SearchTerm" : this.state.searchInput
      }
        this.props.getAllPODetails(input_obj)
      }

 // ? handle search input
 handleISearch = (e) => {       
  let searchInput = e.target.value
  this.setState({
      searchInput
  })
  console.log(this.state.searchInput)
  
} 



// ? handle searching
handleSearching = async() => {
    
    let searchTerm = this.state.searchInput
    var input_obj = {
      "OrderId": this.state.orderId,
      "ProjectId": this.state.projectId,
      "VendorId": this.state.supplierId,
      "SearchTerm" : this.state.searchInput
  }
    await this.props.getAllPODetails(input_obj)
    await this.setState({ searchInput: "" })

  }
     
    render()
    {
      var roles = authInstance.getRoles()
      var groups = authInstance.getGroups()
      console.log("roles",roles);
        return(
            <div className="Container-fluid pageheight"  >
               

               <div className="Container-fluid p-4" style={{opacity:this.state.opacity}}>
                    <div className="row pr-4" >
                        <div className="col-md-4"></div>
                          
                          
                          <div className="col-md-4 pt-2 ">
                                  {/* <Link  to ={{ pathname: '',state : {} }}>
                                      <button className="btn2 btn-sms1  float-right" type="submit">Upload Dispatch Clearence</button>
                                  </Link> */}
                          </div>
                          
                          <div className="col-md-4 pt-2  xs={last}">
                            <SearchBar placeholder="Search" value={this.state.searchInput} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search"  btnName=""  />
                          {/* <SearchBar placeholder="Search"  label="Search"  btnName=""  /> */}
                          </div>
                      </div>
                     
                    <div className="row pr-4  pt-4" >
                      {this.state.orderId ?
                        <div className=" col-3 ml-2">
                          <b>Order No: </b>{this.state.orderNo}
                        </div>
                      :null}

                      {this.state.projectId?
                        <div className="col-3 ml-2 ">
                        <b>Project No:</b> {this.state.projectNo}
                        </div> 
                      :null}
                          
                          
                          {!roles[5] && this.state.supplierId?
                          <div className="col-4 ml-2">
                           <b>Supplier :</b> {this.state.supplierName}
                          </div>
                          :<></>} 
                    </div>
               
                <br />

                <div className="row-md-8 pr-4">
                    <div className="col ">
                        <div className="row  headerbar ">
                        {/* <div className="col-md-1 pt-2 pb-2 checkboxheaderbar borderheaderbar">
                            <input type="checkbox" onChange={() => this.handleChange()} checked={this.state.selectAll}/>                           
                          </div> */}
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar">PO Number</div>
                            {/* <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">PO LineItem ID</div> */}
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar">Created On</div>
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar">PO Amount</div>
                            <div className="col-md-3 pt-2 pb-2 borderheaderbar">Action</div>
                        </div>
                        {this.props.poDetails.allPoDetails && this.props.poDetails.allPoDetails.recordset && this.props.poDetails.allPoDetails.recordset.length>0 && this.props.poDetails.allPoDetails.recordset.map((element,Index)=>
                        // {this.state.tableData.map((element,Index)=>
                        <div className={Index%2==0? 'row border ':'row  background '} 
                            onClick={()=>this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                              {/* <div className="col-md-1 pt-2 pb-2 borderheaderbar">    
                                <input key={element.id} type='checkbox'name={element.PoName} value={element.PoName} checked={this.state.checked[Index]} onChange={() => this.handleSingleCheckboxChange(Index)} />        
                            </div> */}
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">{element.PoNo}</div>
                           {/* <div className="col-md-2 pt-2 pb-2 borderheaderbar amount-text headeralign">{element.POLineItemSAPCode}</div> */}
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar d-none d-sm-block headeralign">{dateFormater(element.PO_CreatedOn)}</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign">{numberWithCommas(element.Currency + ' ' + element.POAmount)}</div>
                           <div className="col-md-3 pt-2 pb-2 borderheaderbar modal-text">
                            <Link  to ={{ pathname: '/UploadDispatchClearence',state : { poId: element.PoNo , supId:this.state.supplierId , ProjectId:this.state.projectId, OrderId:this.state.orderId} }}>
                              <FontAwesomeIcon icon={"eye"} color={"black"} title="View" size="lg"  />
                            </Link>
                           </div>
                           
                             
                         <div  style={{maxWidth:"1400px"}}  className={Index==this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${Index}` : `container collapse` }> 
                         <form>
                                            <div></div>
                                           

                                            <div className="row">
                                              <div className="col-md-6">
                                                {/* <div className="row">
                                                  <div className="col">
                                                    <b>WBS Number:</b>
                                                  </div>
                                                  <div className="col">
                                                    {element.WBSNo}
                                                  </div>
                                                </div> */}

                                                <div className="row mt-2">
                                                  <div className="col">
                                                    <b>Location:</b>
                                                  </div>
                                                  <div className="col">
                                                    {element.Location}
                                                  </div>
                                                  
                                                </div>
                                                <div className="row mt-2">
                                                  <div className="col">
                                                    <b>Item Description:</b>
                                                  </div>
                                                  <div className="col">
                                                  {/* {element.PoLineItemQuantity + ' ' +element.OrderUnit} */}
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="col-md-6">

                                                {/* <div className="row">
                                                  <div className="col">
                                                    <b>PO Amount:</b>
                                                  </div>
                                                  <div className="col">
                                                  {element.Currency + ' ' + element.POLineItemAmount}
                                                  </div>
                                                </div> */}
                                                <div className="row mt-2">
                                                  <div className="col">
                                                    <b>PO Quantity:</b>
                                                  </div>
                                                  <div className="col">
                                                  {element.PoLineItemQuantity + ' ' +element.OrderUnit}
                                                  </div>
                                                </div>
                                              </div>                                            
                                            </div>                                           
                                       <br/>                                             
                                          </form>
                         </div>
                        </div>
                        )}           

                    </div>
                </div>
                 
  
            </div>
            </div>
            
        )
    }
}

const mapStateToProps  = (state) => ({poDetails:state.projectNoReducer})
export default connect(mapStateToProps,{getAllPODetails}) (Dashboard);